const list = [
  {fileName: "/third_party/publicdomainvectors/camera.png", title: "Camera"},
  {fileName: "/third_party/publicdomainvectors/cat.png", title: "Cat"},
  {fileName: "/third_party/publicdomainvectors/dog.png", title: "Dog"},
  {fileName: "/third_party/publicdomainvectors/dollar-sign.png", title: "Dollar sign"},
  {fileName: "/third_party/publicdomainvectors/dragon.png", title: "Dragon"},
]

export default { list };